import { motion } from "framer-motion";
import { Star } from "lucide-react";

export default function Testimonials({ t }) {
  const reviews = t.testimonials.reviews;

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-20 md:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <p className="text-xs tracking-[0.3em] sm:tracking-[0.38em] uppercase text-[#D4AF37] font-body mb-4">
            {t.testimonials.sectionTitle}
          </p>
          <h2
            className="text-4xl md:text-5xl font-bold text-white font-heading"
            data-testid="testimonials-title"
          >
            {t.testimonials.headline}
          </h2>
        </motion.div>

        <div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
          data-testid="testimonials-grid"
        >
          {reviews.map((review, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.65, delay: i * 0.09 }}
              className="bg-[#0F0F0F] border border-white/5 p-8 hover:border-[#D4AF37]/20 transition-colors duration-500 group"
              data-testid={`testimonial-card-${i}`}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {Array.from({ length: 5 }).map((_, si) => (
                  <Star key={si} size={13} className="text-[#D4AF37] fill-[#D4AF37]" />
                ))}
              </div>

              {/* Opening quote mark */}
              <p className="text-[#D4AF37]/20 font-heading text-6xl leading-none mb-2 select-none" aria-hidden="true">
                &ldquo;
              </p>

              <p className="text-white/65 font-body text-base leading-relaxed mb-7 italic">
                {review.text}
              </p>

              <div className="w-7 h-[1px] bg-[#D4AF37]/30 mb-5" />

              <p className="text-white font-body font-semibold text-sm tracking-wider">{review.name}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
